var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3999 69.999C54.7299 69.999 70.3999 54.329 70.3999 34.999C70.3999 15.6691 54.7299 -0.000976563 35.3999 -0.000976562C16.0699 -0.000976562 0.399902 15.6691 0.399902 34.999C0.399902 54.329 16.0699 69.999 35.3999 69.999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5814 41.0948L30.5799 27.8899L43.1887 34.5151L30.5814 41.0948ZM58.2664 25.6017C58.2664 25.6017 57.8099 22.3633 56.4114 20.9372C54.6366 19.0646 52.6474 19.0558 51.736 18.9471C45.2056 18.4713 35.4099 18.4713 35.4099 18.4713H35.3895C35.3895 18.4713 25.5939 18.4713 19.0635 18.9471C18.1506 19.0558 16.1629 19.0646 14.3866 20.9372C12.9881 22.3633 12.5331 25.6017 12.5331 25.6017C12.5331 25.6017 12.0664 29.4056 12.0664 33.208V36.7739C12.0664 40.5778 12.5331 44.3802 12.5331 44.3802C12.5331 44.3802 12.9881 47.6187 14.3866 49.0447C16.1629 50.9173 18.4947 50.8586 19.5331 51.0539C23.2664 51.4152 35.3997 51.5268 35.3997 51.5268C35.3997 51.5268 45.2056 51.5121 51.736 51.0363C52.6474 50.9261 54.6366 50.9173 56.4114 49.0447C57.8099 47.6187 58.2664 44.3802 58.2664 44.3802C58.2664 44.3802 58.7331 40.5778 58.7331 36.7739V33.208C58.7331 29.4056 58.2664 25.6017 58.2664 25.6017Z",
    fill: "#005EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.2a347d75cf99516f94b6072648291c9f.svg";
export { ForwardRef as ReactComponent };